import type { JobCostEstimateReason, JobCostState } from "@/typings/jobCost";

// One copy of the Job Cost marker copy and chip colors, shared by the Job Cost
// tab, the job header panel and the Job Costing report.
export interface JobCostMarker {
  label: string;
  tooltip: string;
  color: string;
}

export const STATE_MARKERS: Partial<Record<JobCostState, JobCostMarker>> = {
  in_progress: {
    label: "In progress",
    tooltip: "The job isn't finalized yet, so these numbers will change.",
    color: "blue"
  },
  voided: {
    label: "Voided",
    tooltip: "The invoice was voided, so there is no revenue or profit.",
    color: "gray"
  }
};

export const ESTIMATED_MARKER = {
  label: "Estimated",
  color: "yellow"
} as const;

export const FALLBACK_RATE_TOOLTIP =
  "No hourly labor cost is set for this person, so the job's department rate was used.";
export const RATE_VARIES_TOOLTIP =
  "This person's rate changed between appointments, so hours × the rate shown won't equal their labor cost.";

// A pricebook parts cost is still calculated but not called out, so it has no text here.
const ESTIMATE_REASON_TEXT: Partial<Record<JobCostEstimateReason, string>> = {
  department_rate_fallback: "some labor uses the department rate"
};

export function estimateTooltip(reasons: JobCostEstimateReason[]): string {
  return `Estimated: ${reasons
    .filter((reason) => ESTIMATE_REASON_TEXT[reason])
    .map((reason) => ESTIMATE_REASON_TEXT[reason])
    .join(" and ")}.`;
}
